var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React, { useState } from 'react';
import { useAtomValue } from 'jotai';
import { templatesAtom } from "../../../../../../../../atoms";
import { defaultSearch, MultiselectList } from "../../../../../../../../Components/Forms";
import { useCreateExtractorContext } from "../../CreateExtractorContext";
import { filterPXQualifiedTemplates } from "../../../../../utils/filterPXQualifiedTemplates";
import { formatTemplatesToOptions } from "../../../../../utils/formatters";

const Body = () => {
  const { targetTemplateId, setTargetTemplateId } = useCreateExtractorContext();
  const templates = useAtomValue(templatesAtom);
  const targetTemplateOptions = formatTemplatesToOptions(
    templates.filter(filterPXQualifiedTemplates)
  );
  const [options, setOptions] = useState(targetTemplateOptions);
  return (/*#__PURE__*/
    _jsx("div", { className: "h-96 pt-2" }, void 0, /*#__PURE__*/
    _jsx(MultiselectList, {
      selectedValues: [targetTemplateId],
      items: options,
      onChange: (selected) => {
        setTargetTemplateId(selected[0]);
      },
      onSearch: (s) => setOptions(() => defaultSearch(s, targetTemplateOptions)),
      singleSelect: true,
      hideFilters: true }
    )
    ));

};

export { Body };